import clsx from 'clsx'
import labelClasses from 'components/core-v2/atoms/label/index.module.scss'
import { noop } from 'lodash'
import { ReactNode } from 'react'
import { Controller } from 'react-hook-form'
import { ClassName } from 'types/props'

import { getFieldIds } from './__utils__/getFieldIds'
import classes from './checkbox-field.module.scss'

export enum TRI_STATE_CHECKBOX {
  false = 'false',
  mixed = 'mixed',
  true = 'true'
}

export interface TriStateCheckboxFieldProps extends ClassName {
  ariaControls: string
  id: string
  label: ReactNode
  onClick?: (state: TRI_STATE_CHECKBOX) => void
}

export const TriStateCheckboxField = ({
  ariaControls,
  className,
  id,
  label,
  onClick = noop
}: TriStateCheckboxFieldProps) => {
  const { inputId, labelledBy } = getFieldIds(id)

  return (
    <Controller
      defaultValue={TRI_STATE_CHECKBOX.false}
      name={inputId}
      render={({ field: { onBlur, onChange, ref, value } }) => (
        <div className={className}>
          <div
            ref={ref}
            aria-checked={value}
            aria-controls={ariaControls}
            aria-labelledby={labelledBy}
            className={clsx(classes.label, classes.triStateInput, classes[value])}
            id={inputId}
            role="checkbox"
            tabIndex={0}
            onBlur={onBlur}
            onClick={() => {
              if (value === TRI_STATE_CHECKBOX.false || value === TRI_STATE_CHECKBOX.mixed) {
                onChange(TRI_STATE_CHECKBOX.true)
                onClick(TRI_STATE_CHECKBOX.true)
              }
              if (value === TRI_STATE_CHECKBOX.true) {
                onChange(TRI_STATE_CHECKBOX.false)
                onClick(TRI_STATE_CHECKBOX.false)
              }
            }}
          >
            <div className={classes.wrapper}>
              <span
                className={clsx(classes.checkmark, {
                  [classes.checkmarkHalf]: value === TRI_STATE_CHECKBOX.mixed
                })}
              />
            </div>
            <span className={labelClasses.root} id={labelledBy}>
              {label}
            </span>
          </div>
        </div>
      )}
    />
  )
}
